import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Container, Card, Table, Button, Badge, Spinner, Modal, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import InformacionUsuario from "../modales/InformacionUsuario";
import AvatarCentrado from "../modales/AvatarCentrado";

import {API_BASE} from "../../services/apirest";


export default function RegistroPage() {
  const [list, setList] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState("Registrando");
  const [showFGUModal, setShowFGUModal] = useState(false);
  const [showSiebelModal, setShowSiebelModal] = useState(false);
  const [fguValue, setFguValue] = useState("");
  const [siebelValue, setSiebelValue] = useState("");
  const [showToaModal, setShowToaModal] = useState(false);
  const [toaValue, setToaValue]       = useState("");
  const [searchPhone] = useState("");
  const [searchCVV]   = useState("");
  const [showBodegaModal, setShowBodegaModal] = useState(false);
  const [bodegaUser, setBodegaUser] = useState(null);
  const [credLoading, setCredLoading] = useState(false);
  

  // —— Estados para “Generar Credenciales” ——    
  const [showCredModal, setShowCredModal] = useState(false);
  const isStOn = (row) => Number(row?.st) === 1; // "0" -> 0, "1" -> 1
  const requiresSt = (row) => [9, 13].includes(Number(row?.rol_id));
  const [credForm, setCredForm] = useState({
    ccven: "",
    usuario_red: "",
    numero_vendedor: "",
  });
  // ————————————————————————————————
const openToaModal = (registro) => {
  setSelected(registro);
  setToaValue(registro.fgu_toa || "");
  setShowToaModal(true);
};

const hasBodegaInfo = (row) =>
  !!(
    row?.bodega_distribuidor ||
    row?.bodega_almacen ||
    row?.bodega_nombre ||
    row?.bodega_region ||
    row?.bodega_direccion
  );

const openBodegaModal = (row) => {
  setBodegaUser(row);
  setShowBodegaModal(true);
};


  const headers = useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }),
    []
  );

  const load = useCallback(async () => {
  try {
    // Traemos solo los "Registrando" del backend
    const url = `${API_BASE}/solicitudes.php?Estado=${encodeURIComponent("Registrando")}`;
    const res = await fetch(url, { method: "GET", headers });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();
    const base = data.status === "success" ? (data.result?.solicitudes || []) : [];
    // Filtro en frontend según el select
    const final =
      filterStatus === "Creación de FGU"
        ? base.filter(isFGUIncomplete)
        : filterStatus === "Generar Credenciales"
          ? base.filter(isReadyForCred)
          : base; // "Registrando": muestra todos los Registrando
    setList(final);
  } catch (err) {
    console.error(err);
    setList([]);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [headers, filterStatus]);
// Normalizador para comparar estados sin acentos/espacios/case

// --- Helpers de rol ---
  const isToaPiRole = (roleIdOrSol) => {
    const id = typeof roleIdOrSol === "object" ? roleIdOrSol?.rol_id : roleIdOrSol;
    return [9, 13].includes(Number(id));
  };



const [showPiModal, setShowPiModal] = useState(false);
const [piValue, setPiValue] = useState("");
const openPiModal = (registro) => {
  setSelected(registro);
  setPiValue(registro.fgu_pi || "");
  setShowPiModal(true);
};

const needsTOA = (s) => isToaPiRole(s);
const needsPI  = (s) => isToaPiRole(s);

const isFGUIncomplete = (s) =>
  !s.fgu_usuario ||
  !s.red_siebel_telcom ||
  (needsTOA(s) && !s.fgu_toa) ||
  (needsPI(s)  && !s.fgu_pi);

  const canShowGenerateCred = (s) => {
    const fguReady =
        s.red_siebel_telcom &&
        s.fgu_usuario &&
        (!isToaPiRole(s) || (s.fgu_toa && s.fgu_pi)); // si es 9/13, exige TOA y PI

    const credsMissing = !s.ccven || !s.usuario_red || !s.numero_vendedor;
    const stOk = !requiresSt(s) || isStOn(s); // si requiere ST, debe estar en 1

    return fguReady && credsMissing && stOk;
  };

const isReadyForCred = (s) =>
    !isFGUIncomplete(s) &&
     (!s.ccven || !s.usuario_red || !s.numero_vendedor) &&
    (!requiresSt(s) || isStOn(s));

  useEffect(() => {
    load();
    const poll = setInterval(load, 30000);
    return () => clearInterval(poll);
  }, [load]);
    // Filtrado combinando Teléfono y CVV
  const filteredList = useMemo(() => {
    if (!Array.isArray(list)) return [];
    return list.filter(s => {
      const matchesPhone = searchPhone
        ? s.telefono.includes(searchPhone)
        : true;
      const matchesCVV = searchCVV
        ? s.numero_vendedor.includes(searchCVV)
        : true;
      return matchesPhone && matchesCVV;
    });
  }, [list, searchPhone, searchCVV]);

  const sortedList = useMemo(() => {
     return [...filteredList].sort((a, b) => new Date(b.Fecha) - new Date(a.Fecha));
    }, [filteredList]);
  // Actualiza estado a Completada

  // —— Abrir modal de credenciales ——
  const openCredModal = (registro) => {
    setSelected(registro);
    setCredForm({
      usuario_red: registro.usuario_red         || "",
      ccven: registro.ccven || "",
      numero_vendedor: registro.numero_vendedor || "",
    });
    setShowCredModal(true);
  };
  // ——————————————————————————————————
  const exportToCsv = () => {
    if (!list || list.length === 0) return;
    
    const headersCsv = [
      "EMAIL",
      "NOMBRE DE VENDEDOR",
      "RFC",
      "TELEFONO",
      "FECHA ALTA",
    ];

    const rows = list.map((s) => [
      s.usuario,
      `${s.nombre_usuario} ${s.apellido_paterno} ${s.apellido_materno}`.trim(),
      s.rfc,
      s.telefono,
      new Date(s.Fecha).toLocaleDateString(),
    ]);

    const csvContent = [headersCsv, ...rows]
      .map((e) => e.join(","))
      .join("\n");

    const safeStatus = (filterStatus || "Todos").replace(/\s+/g, "_").toLowerCase();
    const fileName = `registro_${safeStatus}.csv`;

    const blob = new Blob(["\uFEFF" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (list === null) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <div className="app-container">
      <Container className="my-5">
        <div className="d-flex align-items-end mb-3">
          <Form.Group
            controlId="statusFilter"
            className="me-3 mb-0"
            style={{ minWidth: "200px" }}
          >
            <Form.Label>Filtrar por Estado:</Form.Label>
              <Form.Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                
                <option value="Registrando">Registrando</option>
                <option value="Creación de FGU">Creación de FGU</option>
                <option value="Generar Credenciales">Generar Credenciales</option>
              </Form.Select>
          </Form.Group>
          <Button variant="success" onClick={exportToCsv} className="mb-2">
            Exportar
          </Button>
        </div>

        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Solicitudes</h5>
            <Badge bg={list.length > 0 ? "info" : "secondary"} pill>
              {list.length}
            </Badge>
          </Card.Header>
          <Card.Body>
            {list.length === 0 ? (
              <p className="text-center text-muted">No hay registros con ese estado.</p>
            ) : (
              <Table responsive hover striped className="mb-0 align-middle">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>RFC</th>
                    <th>Teléfono</th>
                    <th>Fecha</th>
                     {["Registrando", "Creación de FGU", "Generar Credenciales"].includes(filterStatus) && (
                         <th className="text-center">Acción</th>
                     )}
                  </tr>
                </thead>
                <tbody>
                  {sortedList.map((s) => (
                    <tr
                      key={s.SolicitudId}
                      style={{ cursor: "pointer" }}
                      onClick={() => { setSelected(s); setShowDetailModal(true); }}
                    >
                      <td>{s.nombre_usuario} {s.apellido_paterno} {s.apellido_materno}</td>
                      <td>{s.rfc}</td>
                      <td>{s.telefono}</td>
                      <td>{new Date(s.Fecha).toLocaleDateString()}</td>
                        {["Registrando", "Creación de FGU", "Generar Credenciales"].includes(filterStatus) && (
                      <td className="text-center">
                        {/* Paso 1: FGU USUARIO RED */}
                        {!s.red_siebel_telcom && (
                          <Button
                            variant="primary"
                            size="sm"
                            className="me-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelected(s);
                              setSiebelValue(s.red_siebel_telcom || "");
                              setShowSiebelModal(true);
                            }}
                          >
                            FGU USUARIO RED
                          </Button>
                        )}
                        {/* Paso 2: FGU SIEBEL TELCO */}
                        {!s.fgu_usuario && (
                          <Button
                            variant="info"
                            size="sm"
                            className="me-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelected(s);
                              setFguValue(s.fgu_usuario || "");
                              setShowFGUModal(true);
                            }}
                          >
                            FGU SIEBEL TELCO
                          </Button>
                        )}

                        {isToaPiRole(s) && !s.fgu_pi && (
                          <Button
                            variant="secondary"
                            size="sm"
                            className="me-2"
                            onClick={(e) => { e.stopPropagation(); openPiModal(s); }}
                          >
                            FGU PI
                          </Button>
                        )}
                        {/* Paso 3: FGU TOA SOLO para rol 9 y 13 */}
                        {isToaPiRole(s) && !s.fgu_toa && (
                          <Button
                            variant="secondary"
                            size="sm"
                            className="me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              openToaModal(s);
                            }}
                          >
                            FGU TOA
                          </Button>
                        )}

                        {requiresSt(s) && !isStOn(s) && (
                            <div
                                className="d-inline-block me-2"
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                            >
                             <Form.Check
                                  inline
                                  type="checkbox"
                                  id={`chk-st-${s.SolicitudId}`}
                                  label="ST"
                                  checked={isStOn(s)}
                                  onChange={async (e) => {
                                    e.stopPropagation();
                                    const next = 1;
                                    const res = await fetch(`${API_BASE}/solicitudes.php`, {
                                      method: "PUT",
                                      headers,
                                      body: JSON.stringify({ SolicitudId: s.SolicitudId, st: next }),
                                    });
                                    const j = await res.json();
                                    if (j.status === "success" || j.status === "ok") {
                                      window.dispatchEvent(new Event("solicitudes:refresh"));
                                      window.dispatchEvent(new Event("inbox:refresh"));
                                      // Actualiza la lista local
                                      setList((prev) =>
                                        (prev || []).map((it) =>
                                          it.SolicitudId === s.SolicitudId ? { ...it, st: next } : it
                                        )
                                      );

                                      // Si tiene info de bodega, abre el modal
                                      if (hasBodegaInfo(s)) {
                                        openBodegaModal(s);
                                      }
                                    } else {
                                      Swal.fire(
                                        "Error",
                                        j.result?.error_msg || j.message || "No se pudo guardar ST",
                                        "error"
                                      );
                                    }
                                  }}
                                />

                            </div>
                        )}

                        {/* Generar Credenciales:
                             si rol ≠ 9: basta con los 2 primeros pasos
                             si rol = 9: necesita los 3 pasos */}

                        {canShowGenerateCred(s) &&  (
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              openCredModal(s);
                            }}
                          >
                            Generar Cred.
                          </Button>
                        )}
                      </td>
                    )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
        {/* Modal de detalle */}
        {selected && (
          <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered dialogClassName="modal-100w" style={{ zIndex: 11000 }}>
            <Modal.Header closeButton>
              <Modal.Title>Detalle Registro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selected.foto_url && (
                <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />
              )}
              <InformacionUsuario
                  user={selected}
                  title="Datos del agente"
                  cols={3}
                  fields={[
                    { key: "distribuidor_nombre", label: "Distribuidor" },
                    { key: "distribuidor_rs",     label: "Razón Social" },
                    { key: "usuario",             label: "Email" },
                    {
                      key: "nombre",
                      label: "Nombre completo",
                      render: (u) => [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                          .filter(Boolean)
                          .join(" ")
                    },
                    { key: "rfc",                 label: "RFC", render: (u) => (u?.rfc || "").toUpperCase() },
                    { key: "telefono",            label: "Teléfono" },
                    { key: "Fecha",               label: "Fecha Ingreso", render: (u) => u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—" },
                    { key: "numero_vendedor",     label: "Número Empleado" },
                  ]}

                  
              />

                {/* 5) Bodega (SOLO si hay datos) */}
                    {(
                      selected?.bodega_distribuidor ||
                      selected?.bodega_almacen ||
                      selected?.bodega_nombre ||
                      selected?.bodega_region ||
                      selected?.bodega_direccion
                    ) && (
                      <InformacionUsuario
                        user={selected}
                        title="Bodega"
                        cols={2}
                        hideEmpty={true}
                        fields={[
                          { key: "bodega_distribuidor", label: "Distribuidor" },
                          { key: "bodega_almacen",      label: "Almacén" },
                          { key: "bodega_nombre",       label: "Bodega" },
                          { key: "bodega_region",       label: "Región" },
                          { key: "bodega_direccion",    label: "Dirección" },
                        ]}
                      />
                    )}
             {/* Mostrar credenciales si existen */}
             {selected.ccven && (
               <p><strong>CVVEN:</strong> {selected.ccven}</p>
             )}
             {selected.usuario_red && (
               <p><strong>Usuario Red:</strong> {selected.usuario_red}</p>
             )}
             {selected.contraseña_red && (
               <p><strong>Contraseña Red:</strong> {selected.contraseña_red}</p>
             )}
              {selected.numero_vendedor && (
               <p><strong>Numero Empleado:</strong> {selected.numero_vendedor}</p>
             )}

             
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDetailModal(false)}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
        )}
        <Modal show={showFGUModal} onHide={() => setShowFGUModal(false)} centered>
  <Modal.Header closeButton><Modal.Title>INGRESAR FGU SIEBEL TELCOM</Modal.Title></Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>FGU SIEBEL TELCOM</Form.Label>
      <Form.Control
        type="text"
        value={fguValue}
        onChange={(e) => setFguValue(e.target.value)}
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowFGUModal(false)}>Cancelar</Button>
    <Button variant="primary" onClick={async () => {
      if (!fguValue.trim()) {
        Swal.fire("Error", "Debes ingresar el valor de FGU", "warning");
        return;
      }
      const payload = { SolicitudId: selected.SolicitudId, fgu_usuario: fguValue.trim() };
      const res = await fetch(`${API_BASE}/solicitudes.php`, {
        method: "PUT",
        headers,
        body: JSON.stringify(payload)
      })
      const data = await res.json();
     if (data.status === "success" || data.status === "ok") {
        Swal.fire("¡LISTO!", "FGU registrado", "success");
        window.dispatchEvent(new Event("solicitudes:refresh"));
        window.dispatchEvent(new Event("inbox:refresh"));
        setShowFGUModal(false); 
        load();
      } else {
          Swal.fire("Error", "No se pudo guardar", "error");
      }
    }}>Guardar</Button>
  </Modal.Footer>
</Modal>

<Modal show={showSiebelModal} onHide={() => setShowSiebelModal(false)} centered>
  <Modal.Header closeButton><Modal.Title>INGRESAR FGU USUARIO RED</Modal.Title></Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>FGU USUARIO RED</Form.Label>
      <Form.Control
        type="text"
        value={siebelValue}
        onChange={(e) => setSiebelValue(e.target.value)}
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowSiebelModal(false)}>Cancelar</Button>
    <Button variant="primary" onClick={async () => {
      if (!siebelValue.trim()) {
        Swal.fire("Error", "Debes ingresar el valor de Red Siebel Telcom", "warning");
        return;
      }
      const payload = { SolicitudId: selected.SolicitudId, red_siebel_telcom: siebelValue.trim() };
      const res = await fetch(`${API_BASE}/solicitudes.php`, {
        method: "PUT",
        headers,
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if  (data.status === "success" || data.status === "ok") {
        Swal.fire("¡LISTO!", "Red Siebel Telcom registrado", "success");
        window.dispatchEvent(new Event("solicitudes:refresh"));
        window.dispatchEvent(new Event("inbox:refresh"));
        setShowSiebelModal(false); 
        load();
      } else {
        Swal.fire("Error", "No se pudo guardar", "error");
      }
    }}>Guardar</Button>
  </Modal.Footer>
</Modal>

<Modal show={showPiModal} onHide={() => setShowPiModal(false)} centered>
  <Modal.Header closeButton><Modal.Title>INGRESAR FGU PI</Modal.Title></Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>FGU PI</Form.Label>
      <Form.Control
        type="text"
        value={piValue}
        onChange={(e) => setPiValue(e.target.value)}
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPiModal(false)}>Cancelar</Button>
    <Button variant="primary" onClick={async () => {
      if (!piValue.trim()) return Swal.fire("Error","Debes ingresar un valor","warning");
      const res = await fetch(`${API_BASE}/solicitudes.php`, {
        method: "PUT",
        headers,
        body: JSON.stringify({ SolicitudId: selected.SolicitudId, fgu_pi: piValue.trim() })
      });
      const data = await res.json();
      if (data.status === "success" || data.status === "ok") {
        Swal.fire("¡LISTO!", "FGU PI registrado", "success");
        setShowPiModal(false); load();
      } else {
        Swal.fire("Error", data.result?.error_msg || "No se pudo guardar", "error");
      }
    }}>Guardar</Button>
  </Modal.Footer>
</Modal>

<Modal
  show={showToaModal}
  onHide={() => setShowToaModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>INGRESAR FGU TOA</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>FGU TOA</Form.Label>
      <Form.Control
        type="text"
        value={toaValue}
        onChange={e => setToaValue(e.target.value)}
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowToaModal(false)}>
      Cancelar
    </Button>
    <Button
      variant="primary"
      onClick={async () => {
        if (!toaValue.trim()) {
          return Swal.fire("Error", "Debes ingresar un valor", "warning");
        }
        // Hacemos el PUT exactamente igual que los otros dos
        const payload = {
          SolicitudId: selected.SolicitudId,
          fgu_toa: toaValue.trim()
        };
        const res = await fetch(`${API_BASE}/solicitudes.php`, {
          method: "PUT",
          headers,
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (data.status === "success" || data.status === "ok") {
          Swal.fire("¡LISTO!", "FGU TOA registrado", "success");
          setShowToaModal(false);
          load(); // recarga la lista: ahora s.fgu_toa ya no está vacío y el botón desaparece
        } else {
          Swal.fire("Error", data.result?.error_msg || "No se pudo guardar", "error");
        }
      }}
    >
      Guardar
    </Button>
  </Modal.Footer>
</Modal>
        {/* Modal Generar Credenciales */}
        <Modal show={showCredModal} onHide={() => setShowCredModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Generar Credenciales</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>USUARIO DE RED</Form.Label>
                <Form.Control type="email" value={credForm.usuario_red} onChange={(e) => setCredForm((prev) => ({ ...prev, usuario_red: e.target.value }))} />
              </Form.Group>


              <Form.Group className="mb-3">
                <Form.Label>CLAVE DE VENDEDOR</Form.Label>
                <Form.Control
                  type="text"
                  value={credForm.ccven}
                  style={{ textTransform: "uppercase" }}       
                  autoCapitalize="characters"                  
                  onChange={(e) =>
                    setCredForm((prev) => ({
                      ...prev,
                      ccven: e.target.value.toUpperCase(), // se guarda en mayúsculas
                    }))
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>NÚMERO DE EMPLEADO</Form.Label>
                <Form.Control type="text" value={credForm.numero_vendedor} onChange={(e) => setCredForm((prev) => ({ ...prev, numero_vendedor: e.target.value }))} />
              </Form.Group>

            </Form>
          </Modal.Body>
          <Modal.Footer>

            <Button variant="secondary" onClick={() => setShowCredModal(false)}>
              Cancelar
            </Button>

              <Button
                variant="primary"
                disabled={
                  credLoading ||
                  (
                    !credForm.ccven.trim() &&
                    !credForm.usuario_red.trim() &&
                    !credForm.numero_vendedor.trim()
                  )
                }
                onClick={async (e) => {
                  e.stopPropagation();

                  const payload = { SolicitudId: selected.SolicitudId };
                  const cs = credForm.ccven.trim();
                  const ur = credForm.usuario_red.trim();
                  const nv = credForm.numero_vendedor.trim();

                  if (cs) payload.ccven = cs;
                  if (ur) payload.usuario_red = ur;
                  if (nv) payload.numero_vendedor = nv;

                  // Defensa extra por si acaso
                  if (Object.keys(payload).length === 1) {
                    return Swal.fire(
                      "Error",
                      "Debes completar al menos un campo antes de guardar",
                      "warning"
                    );
                  }

                  try {
                    setCredLoading(true); // 🔁 empieza loading

                    // 2) Guardar cambios parciales (sin forzar estado)
                    const res = await fetch(`${API_BASE}/solicitudes.php`, {
                      method: "PUT",
                      headers,
                      body: JSON.stringify(payload),
                    });
                    const d = await res.json();
                    if (d.status !== "success" && d.status !== "ok") {
                      return Swal.fire(
                        "Error",
                        d.result?.error_msg || "Fallo al guardar",
                        "error"
                      );
                    }

                    // 3) Calcular cómo quedará el registro tras este guardado (merge local)
                    const merged = {
                      ccven: cs || selected.ccven || "",
                      usuario_red: ur || selected.usuario_red || "",
                      numero_vendedor: nv || selected.numero_vendedor || "",
                    };
                    const allThree =
                      merged.ccven && merged.usuario_red && merged.numero_vendedor;

                    if (allThree) {
                      const res2 = await fetch(`${API_BASE}/solicitudes.php`, {
                        method: "PUT",
                        headers,
                        body: JSON.stringify({
                          SolicitudId: selected.SolicitudId,
                          Estado: "Completado",
                        }),
                      });
                      const d2 = await res2.json();
                      if (d2.status !== "success" && d2.status !== "ok") {
                        Swal.fire(
                          "Aviso",
                          d2.result?.error_msg || "No se pudo completar el registro",
                          "warning"
                        );
                      }
                    }

                    Swal.fire("¡LISTO!", "Credenciales registradas", "success");
                    window.dispatchEvent(new Event("solicitudes:refresh"));
                    window.dispatchEvent(new Event("inbox:refresh"));
                    setShowCredModal(false);
                    load();
                  } catch (err) {
                    console.error(err);
                    Swal.fire("Error", "No se pudo conectar al servidor", "error");
                  } finally {
                    setCredLoading(false); // 🔁 termina loading
                  }
                }}
              >
                {credLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Enviando...
                  </>
                ) : (
                  "ENVIAR"
                )}
              </Button>

          </Modal.Footer>
        </Modal>

        {bodegaUser && (
  <Modal
    show={showBodegaModal}
    onHide={() => setShowBodegaModal(false)}
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>Información de Bodega</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <InformacionUsuario
        user={bodegaUser}
        title="Bodega"
        cols={2}
        hideEmpty={true}
        fields={[
          { key: "bodega_distribuidor", label: "Distribuidor" },
          { key: "bodega_almacen",      label: "Almacén" },
          { key: "bodega_nombre",       label: "Bodega" },
          { key: "bodega_region",       label: "Región" },
          { key: "bodega_direccion",    label: "Dirección" },
        ]}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowBodegaModal(false)}>
        Cerrar
      </Button>
    </Modal.Footer>
  </Modal>
)}
      </Container>
    </div>
  );
}
